export class AppConsts {
  //static remoteServiceBaseUrl: string = "https://connectidt.smithsnews.co.uk";
  static remoteServiceBaseUrl: string = "https://connectid.smithsnews.co.uk";
  // static remoteServiceBaseUrl: string = "https://smiths-test.connectid.software";
  // static remoteServiceBaseUrl: string = "https://smiths-nrs.connectid.software"; // Test Server Smith News
  //static remoteServiceBaseUrl: string = "https://smiths-nrs.connectid.software";

  static appBaseUrl: string = "";

  static mqttMessageBrokers: string = "";
  static mqttMessageBrokerPort: string = "";

  // static remoteServiceBaseUrl: string = "http://10.10.3.104:8009";
  // static appBaseUrl: string = "http://10.10.3.124:4200";

  static version:any = "2.32"
}
